import React, {useEffect, useState} from 'react'
import { useLocation } from 'react-router-dom'
import Burger from '../components/Burger'

/*import { motion as m } from 'framer-motion'*/
import Search from '../components/Search'

export default function Header({ bgColour, titleColour }) {

  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [displaySearchbar, setDisplaySearchbar] = useState(true)

  const location = useLocation()
  const pathname = location.pathname

  useEffect(()=>{
    if (pathname === "/search" || pathname === "/recipes-you-like") {
      setDisplaySearchbar(true)
    } else {
      setDisplaySearchbar(false)
    }
  }, [pathname])

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [screenWidth])
  
  return (
    <>
      <div id='header_container' style={{backgroundColor: bgColour}}>
        {screenWidth >= 800 ? 
          <h1 id='header_logo' style={{color: titleColour}} onClick={()=>{window.location="/"}} >
            What's in your fridge?
          </h1>
    :
          <h1 id='header_logo' style={{color: titleColour, fontSize: "1rem", fontWeight:'700' }} onClick={()=>{window.location="/"}} >
            What's<br/>in your<br/>fridge?
          </h1>
      }
        {displaySearchbar &&
          <Search bgColour={bgColour} titleColour={titleColour} screenWidth={screenWidth}/>
        }
          <Burger />
      </div>
    </>
  )
}
